import React, { useState } from "react";
import axios from "axios";
import "./App.css";
import InfoWeather from "./InfoWeather";
import Forecast from "./Forecast";

export default function Search(props) {
  let [city, setCity] = useState(props.defaultCity);
  let [weather, setWeather] = useState({ ready: false });

  function changeCity(event) {
    setCity(event.target.value);
  }

  function handleSubmit(event) {
    event.preventDefault();
    calcWeather(city);
  }

  function handleReferance(newCity, event) {
    event.preventDefault();
    calcWeather(newCity);
  }

  function handleCurrent(event) {
    event.preventDefault();
    navigator.geolocation.getCurrentPosition(getCityByCoords);
  }

  function getCityByCoords(position) {
    let key = `ff1d9ea9376b5c27a82e04fc2b2abdbb`;
    let url = `https://api.openweathermap.org/data/2.5/weather?lat=${position.coords.latitude}&lon=${position.coords.longitude}&appid=${key}&units=metric`;

    https: axios.get(url).then(viewWeather);
  }

  function calcWeather(newCity) {
    let key = `ff1d9ea9376b5c27a82e04fc2b2abdbb`;
    let url = `https://api.openweathermap.org/data/2.5/weather?q=${newCity}&appid=${key}&units=metric`;

    axios.get(url).then(viewWeather);
  }

  function viewWeather(response) {
    setWeather({
      ready: true,
      city: response.data.name,
      temp: Math.round(response.data.main.temp),
      description: response.data.weather[0].main,
      humidity: response.data.main.humidity,
      wind: Math.round(response.data.wind.speed),
      icon: response.data.weather[0].icon,
      data: new Date(response.data.dt * 1000),
      coords: response.data.coord,
    });
  }

  if (weather.ready) {
    return (
      <div className="Search">
        <div className="refCountries mb-2">
          <a href="#" onClick={(event) => handleReferance("Lisbon", event)}>
            Lisbon
          </a>
          <a href="#" onClick={(event) => handleReferance("Paris", event)}>
            Paris
          </a>
          <a href="#" onClick={(event) => handleReferance("Sydney", event)}>
            Sydney
          </a>
          <a
            href="#"
            onClick={(event) => handleReferance("San Francisco", event)}
          >
            San Francisco
          </a>
        </div>
        <form action="" className="searchForm" onSubmit={handleSubmit}>
          <div className="row g-0">
            <div className="col-8">
              <input
                type="text"
                className="form-control"
                placeholder="Type a city"
                onChange={changeCity}
              />
            </div>
            <div className="col-4">
              <input
                type="submit"
                className="btn btn-outline-primary"
                value="Search"
              />
              <input
                type="submit"
                onClick={handleCurrent}
                className="btn btn-outline-success ms-2"
                value="Current"
              />
            </div>
          </div>
        </form>
        <InfoWeather weather={weather} />
        <Forecast coords={weather.coords} />
      </div>
    );
  } else {
    calcWeather(city);
    return "Loading...";
  }
}
